<template>
  <div>
    <div
      v-if="current.estado =='A'"
      class="floated-chat-btn"
      style="z-index: 1000 !important"
      @click="abrirModal()"
    >
      <i class="fas fa-check"></i>&nbsp;&nbsp;Pickear
    </div>
    <div
      class="modal fade"
      id="pickearModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Pickear Producto</h6>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <h6
              style="color: green"
              v-if="currentDetalle && currentDetalle.producto"
            >
              {{ currentDetalle.producto.sku }}
              {{ currentDetalle.producto.nombre }} <br />
            </h6>
            <small v-if="errors" class="form-text text-danger">{{
              errors.producto
            }}</small>
            <div class="form-group">
              <label v-if="!currentDetalle.producto">Producto</label>
              <input
                v-if="!currentDetalle.producto"
                @change="refreshProducto(barra)"
                class="form-control"
                placeholder="Producto"
                type="text"
                v-model="barra"
                ref="productox"
              />
              <button
                v-if="currentDetalle.producto"
                @click="clearProducto()"
                class="btn btn-md btn-block btn-dark"
              >
                Cambiar Producto
              </button>
            </div>
            <div class="row">
              <div class="col-12" v-if="currentDetalle.producto_lote">
                <label>Producto Lote</label
                ><select
                  class="form-control"
                  v-model="currentDetalle.producto_lote"
                >
                  <option
                    v-for="lote in productos_lotes"
                    v-bind:key="lote.id"
                    :value="lote.id"
                    ref="lotex"
                  >
                    {{ lote.id }} - {{ lote.codigo_lote }} -
                    {{ lote.fecha_fabricacion }}
                  </option>
                </select>
                <small
                  v-if="errors && errors.producto_lote"
                  class="form-text text-danger"
                  >{{ errors.producto_lote[0] }}</small
                >
                <br />
              </div>
              <div class="col-6" v-if="currentDetalle.producto_lote">
                <label>Posición origen</label>
                <input
                  class="form-control"
                  placeholder="Barra posicion"
                  type="text"
                  v-model="currentDetalle.posicion"
                  ref="posicionx"
                  v-on:keyup.enter="nextInputFocus()"
                />
              </div>
              <div class="col-6" v-if="currentDetalle.producto_lote">
                <label for>Cantidad</label>
                <input
                  class="form-control"
                  placeholder="Cantidad"
                  type="number"
                  step="0.01"
                  v-model="currentDetalle.cantidad"
                  v-on:keyup.enter="despachar"
                  ref="cantidadx"
                />
              </div>
            </div>
            <small
              v-if="error_pickeo && error_pickeo.detail"
              class="form-text text-danger"
              >{{ error_pickeo.detail }}</small
            >
            <small
              v-if="error_pickeo && error_pickeo.barra"
              class="form-text text-danger"
              >{{ error_pickeo.barra }}</small
            >
            <small
              v-if="error_pickeo && error_pickeo.posicion"
              class="form-text text-danger"
              >{{ error_pickeo.posicion }}</small
            >
            <small
              v-if="error_pickeo && error_pickeo.cantidad"
              class="form-text text-danger"
              >{{ error_pickeo.cantidad }}</small
            >
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-block btn-primary"
              type="button"
              @click="PickearDetalle()"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  props: {
    current: {
      type: Object,
    },
  },
  data() {
    return {
      errors: {
        producto: "",
      },
      currentDetalle: {
        barra: "",
        posicion: "",
        cantidad: "",
        producto_lote: "",
        producto: "",
      },
      error: [],
      error_pickeo: [],
      barra: null,
      cantidad: null,
      lote: null,
      producto: "",
      producto_lote: null,
      productos_lotes: [],

    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.productox.focus();
    });
  },
  methods: {
    refreshProductoLote(producto) {
      let self = this;
      DynamicService.getById("cat", "productos", producto.sku).then(
        (response) => {
          self.productos_lotes = response.data.productolote_set;
          self.currentDetalle.producto_lote = self.productos_lotes[0].id;
          setTimeout(function () {
            self.$refs.posicionx.focus();
          }, 100);
        }
      );
    },
    nextInputFocus() {
      this.$refs.cantidadx.focus();
    },
    abrirModal() {
      $("#pickearModal").modal("show");
    },
    clearProducto() {
      this.currentDetalle.producto = "";
      this.barra = "";
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle.producto = null;
      self.barra = "";
      self.currentDetalle.cantidad = "";
      self.currentDetalle.posicion = "";
      self.currentDetalle.errors = [];
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          if (response.data.count == 0) {
            self.errors.producto = "No existe producto";
            return;
          }
          self.currentDetalle.producto = response.data.results[0].producto_obj;
          self.currentDetalle.barra = self.currentDetalle.producto.sku;
          self.errors.producto = "";
          self.refreshProductoLote(self.currentDetalle.producto);
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },

    cleanDataErrors() {
      this.error_pickeo = "";
    },
    PickearDetalle() {
      let self = this;
      DynamicService.postAction(
        "inv",
        "transferencia_stock",
        self.current.id,
        "agregar_detalle",
        self.currentDetalle
      )
        .then((response) => {
          self.cleanDataErrors();
          $("#pickearModal").modal("hide");
          self.refreshDetalleDefault();
          this.$emit("refreshCurrent");
        })
        .catch((err) => {
          if (err.response.data) {
            self.error_pickeo = err.response.data;
          }
        });
    },
  },
};
</script>
